import { Button } from '@wbk/ui';
import { WebSection } from '@wbk/contentful/api';
import { parseSectionItem } from '@wbk/contentful';
import { Link, useRouter } from '@wbk/config';
import { useAnalytics } from '@wbk/analytics';
import FunCard from '../events/FunCard';
import ScrollTitle from '../ui/ScrollTitle';

export default function Fun({ section }: { section: WebSection }) {
  const { locale } = useRouter();
  const { trackEvent } = useAnalytics();
  const items = section.contentCollection.items;
  if (!items?.length) return null;

  return (
    <div className='container-padding container'>
      <section className='container space-y-12 px-3 xl:px-0'>
        <ScrollTitle title={section.title} />

        <div className='grid grid-cols-2 gap-2 sm:gap-3 md:gap-4 lg:grid-cols-3 lg:gap-8'>
          {items.map((item, index) => {
            const parsed = parseSectionItem({ item, locale });
            if (!parsed) return null;
            const isLink = !!parsed.href && parsed.href !== '#';
            const isExternal = isLink && parsed.href?.startsWith('http');

            return (
              <Button
                as={isLink ? Link : 'div'}
                href={parsed.href ? parsed.href : '#'}
                theme='white'
                shape='text'
                className='h-full w-full p-0'
                key={index}
                target={isExternal ? '_blank' : undefined}
                onClick={() => {
                  trackEvent({
                    event: 'clicked_on_section_item',
                    data: {
                      type: item.__typename,
                      slug: 'slug' in item ? item.slug : '',
                      section: section.id,
                      position: index,
                    },
                  });
                }}
                rel='noreferrer'
              >
                <FunCard
                  key={index}
                  buttonText={parsed.title}
                  imageUrl={parsed?.background?.url ?? '/images/default-cover.png'}
                  imageAlt='Gourmet dish with fried egg'
                  // onButtonClick={handleGetTickets}
                  className='max-h-[128px] sm:max-h-72'
                />
              </Button>
            );
          })}
        </div>
      </section>
    </div>
  );
}
